import {
  Fit,
  Layout,
  useRive,
  useStateMachineInput,
} from '@rive-app/react-canvas'
import { motion } from '~/lib/motion'
import type { PreviewAnimState } from '~/features/reward-flow/store'
import { rewardFlow } from '~/features/reward-flow/store'
import rewardRiv from '~/assets/rive/reward.riv'

export function PreviewAnim({ state }: { state: PreviewAnimState }) {
  const { variant } = state

  const { RiveComponent, rive } = useRive({
    src: rewardRiv,
    autoplay: true,
    artboard: 'reward_preview',
    stateMachines: ['State Machine 1'],
    layout: new Layout({ fit: Fit.FitHeight }),
    onStateChange: ({ data }) => {
      if (typeof data === 'object' && 'length' in data) {
        const [state] = data as string[]
        if (state === 'exit') {
          rewardFlow.endPreviewAnim()
        }
      }
    },
  })
  const previewInput = useStateMachineInput(rive, 'State Machine 1', 'status')
  if (previewInput) {
    previewInput.value = variant === 'big' ? 2 : 1
  }

  return (
    <motion.div
      className="mb-auto mt-auto h-[40vh] w-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <RiveComponent />
    </motion.div>
  )
}
